import Backbone from 'backbone'
import _ from 'lodash'
import constants from 'scoreboard/components/constants'
import ObjectSelector from 'scoreboard/components/object-selector'
import template from './select-scorecard-form.hbs'
import formHelper from 'scoreboard/components/form-helper'

var SelectScorecardForm = Backbone.View.extend({

	tagName: 'form',

	className: 'select-scorecard-form margin-collapse',

	events: {
		'change input[name=followLinked]' : 'toggleFollowLinked'
	},

	initialize: function(opts) {
		this.options = opts || {}
		this.data = opts.data || {
			id: this.model.id,
			followLinked: this.model.get('followLinked')
		}
	},

	_template: function() {
		return template()
	},

	render: function() {
		this.$el.html(this._template())

		this.$('.follow-linked').toggleClass('is-not-displayed', !!this.options.hideFollowLinked)

		var selectorOpts = { section: constants.SECTION_SCORECARDS, id: this.data.id, autoSelectRoot: true }
		this.objectSelector = new ObjectSelector(selectorOpts)
		this.$('.object-selector').replaceWith(this.objectSelector.el)
		this.objectSelector.render()

		this.listenTo(this.objectSelector, 'select', this.selectObject)
		this.listenTo(this.objectSelector, 'empty', () =>{
			this.trigger('item', null)
		})

		formHelper.writeToDom(this.data, this.el)

		return this
	},

	resize: function() {
		this.objectSelector.resize()
	},

	selectObject: function(item) {
		this.data.item = item
		this.data.id = item.id
		item.linkGroup = this.data.linkGroup || 0
		this.trigger('item', item)
	},

	toggleFollowLinked: function(e) {
		_.assign(this.data, formHelper.readFromDom(this.el))
		this.trigger('followLinked', this.data.followLinked)
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.objectSelector], 'remove')
	}

})

export default SelectScorecardForm

SelectScorecardForm.__filename__ = 'reports/wizard/common/select-scorecard-form.js'
